const FALLBACK_SRC = '/macumba-placeholder.svg'

function isMissingSource(attr) {
  if (attr == null) {
    return true
  }

  const trimmed = attr.trim()
  if (trimmed === '') {
    return true
  }

  const lower = trimmed.toLowerCase()
  return lower === 'null' || lower === 'undefined'
}

function applyFallback(img) {
  if (!(img instanceof HTMLImageElement)) {
    return
  }

  const setFallback = () => {
    if (img.dataset.fallbackApplied === 'true') {
      return
    }

    img.dataset.fallbackApplied = 'true'
    img.src = FALLBACK_SRC
  }

  if (!img.dataset.fallbackBound) {
    const onError = () => {
      if (img.src !== new URL(FALLBACK_SRC, window.location.origin).href) {
        img.dataset.fallbackApplied = 'true'
        img.src = FALLBACK_SRC
      }
    }

    img.addEventListener('error', onError, { once: false })
    img.dataset.fallbackBound = 'true'
  }

  const currentAttr = img.getAttribute('src')
  if (isMissingSource(currentAttr)) {
    setFallback()
  } else if (img.complete && img.naturalWidth === 0) {
    setFallback()
  }
}

function traverseAndApply(root) {
  if (!root) {
    return
  }

  if (root instanceof HTMLImageElement) {
    applyFallback(root)
    return
  }

  if (root.querySelectorAll) {
    const images = root.querySelectorAll('img')
    images.forEach((img) => {
      applyFallback(img)
    })
  }
}

export function registerGlobalImageFallback() {
  // Catch image load errors anywhere in the document
  document.addEventListener(
    'error',
    (event) => {
      const target = event.target
      if (target instanceof HTMLImageElement) {
        applyFallback(target)
      }
    },
    true
  )

  // Catch images that load with an empty/invalid src
  document.addEventListener(
    'load',
    (event) => {
      const target = event.target
      if (target instanceof HTMLImageElement) {
        if (isMissingSource(target.getAttribute('src'))) {
          applyFallback(target)
        }
      }
    },
    true
  )

  // Catch newly added images (replaces the global mixin)
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof HTMLElement) {
          traverseAndApply(node)
        }
      }
    }
  })

  observer.observe(document.body, { childList: true, subtree: true })
}
